<template>
  <div class="htRemark">
    <div class="north">
      <ld-header>
        添加备注
      </ld-header>
    </div>
    <div class="mescroll-box">
      <mescroll-vue
        ref="mescroll"
        :down="{use:false}"
      >
        <div class="remark-box">
          <van-field
            type="textarea"
            rows="5"
            v-model="model.customRemark"
            placeholder="请输入带窗、安静、含早餐、等要求~"
          />
          <div>
            <p class="label">
              快捷标签
            </p>
            <ul class="label-items van-clearfix">
              <li
                v-for="(item, index) in items"
                :key="index"
                :class="item.checked ? 'active main-color' : ''"
                @click="selectLabel(item)"
              >
                {{ item.label }}
              </li>
            </ul>
          </div>
        </div>
      </mescroll-vue>
    </div>
    <div class="remark-footer">
      <ld-button
        main
        size="lg"
        @click="ok"
      >
        {{ $t('B006','确定') }}
      </ld-button>
    </div>
  </div>
</template>

<script>
import { Tab, Tabs , Field} from 'vant'
import { mapState } from 'vuex'
export default {
  name:'HtRemark',
  components: {
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Field.name]: Field,
    MescrollVue: () => import('mescroll.js/mescroll.vue'),
    ldButton: () => import('Common/ldButton'),
  },
  data() {
    return {
      items: [{
        label: '含早餐',
        checked: false
      },{
        label: '有窗户',
        checked: false
      },{
        label: '可以吸烟',
        checked: false
      },{
        label: '无烟房',
        checked: false
      },{
        label: '携带宠物',
        checked: false
      },{
        label: '加床',
        checked: false
      },]
    }
  },
  computed: mapState({
    /**
     * 酒店详情数据模型
     */
    data_: (state) => state.ht.orderDetails,
    model: function (state) {
      return state.ht.htSearchInfo
    },
  }),
  mounted() { },
  created() { },
  methods: {
    ok() {
      this.$router.push({path: '/ht/htQuery/htInquiry'})
    },
    selectLabel(item) {
      item.checked = !item.checked
      if (item.checked) {
        this.model.customRemark = this.model.customRemark + (''+item.label+'、')
      } else {
        this.model.customRemark = this.model.customRemark.replace((''+item.label+'、'), '')
      }
    }
  },
  watch: {}
}
</script>
<style lang="less" scoped >
@import '~Assets/styles/currency/ht.less';
.mescroll-box {
  position: fixed;
  top: 46px;
  left: 0;
  bottom: 60px;
  right: 0;
  overflow: hidden;
}
.remark-box {
  padding: 10px;
  .textarea {
    width: 100%;
    border: solid 1px #2d2d38;
    padding: 10px;
    resize: none;
    border-radius: 3px;
  }
  .label {
    height: 28px;
    line-height: 28px;
    color: #999;
    padding: 0 4px;
  }
  .label-items {
    padding: 0 4px;
    li {
      background-color: #ffffff;
      border-radius: 4px;
      border: solid 1px #eeeeef;
      text-align: center;
      float: left;
      margin: 0 10px 5px 0;
      padding: 4px 10px;
      border: solid 1px #fff;
    }
    li.active {
      border: 1px solid;
    }
  }
}
.remark-footer {
  position: fixed;
  left: 0;
  bottom: 0;
  right: 0;
  padding: 5px 10px;
}
</style>